import { CircularProgress, Stack } from '@mui/material'

interface SpinnerProps {
  fullScreen?: boolean
}

export default function Spinner({ fullScreen = false }: SpinnerProps) {
  const className = fullScreen
    ? 'h-screen w-screen flex flex-row items-center'
    : 'w-full h-full flex flex-row'
  return (
    <div className={className}>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={80}
        width="100%"
        data-testid="spinner"
      >
        <CircularProgress />
      </Stack>
    </div>
  )
}
